import { useNavigate } from "react-router-dom";

export default function CustomInput({
    forgotPassword,
    label,
    value,
    name,
    type,
    handleChange,
    error,
    className,
    labelClassName,
    ...props
}) {
    const navigate = useNavigate()

    const inputClassName = `
    h-12 w-full
    rounded-md
    px-4
    bg-cs-surface
    text-cs-dark
    border
    ${error ? 'border-cs-danger' : 'border-cs-border'}
    shadow-sm
    transition-all duration-200
    focus:outline-none
    focus:ring-2
    ${error ? 'focus:ring-cs-danger/30' : 'focus:ring-cs-primary/30'}
    ${className}
  `

    const labelBaseClass = `
    text-sm
    font-medium
    text-cs-dark
    ${labelClassName}
  `

    const ErrorMensaje = () => {
        if (!error) return null

        return (
            <span className="mt-1 text-sm text-cs-danger">
                {error}
            </span>
        )
    }

    return (
        <div className="flex flex-col w-full py-2 gap-1">
            <div className="flex items-center justify-between">
                <label className={labelBaseClass}>{label}</label>

                {forgotPassword !== undefined && (
                    <button
                        type="button"
                        onClick={() => navigate('/forgotPassword')}
                        className="
              text-sm
              text-cs-primary
              hover:text-cs-primary-hover
              transition-colors
            "
                    >
                        Forgot password?
                    </button>
                )}
            </div>

            <input
                type={type}
                value={value}
                name={name}
                onChange={handleChange}
                className={inputClassName}
                {...props}
            />

            <ErrorMensaje />
        </div>
    );
}
